export const navList = [{
    label: "首页",
    path: "/sunShine"
}, {
    label: "阳光通关",
    path: "/sunShine/port"
}, {
    label: "阳光税务",
    path: "/sunShine/tax"
}, {
    label: "阳光结汇",
    path: "/sunShine/settlement"
}, {
    label: "便捷融资",
    path: "/sunShine/financing"
}, ]


// WEBPACK FOOTER //
// ./src/model/sunShine.js